import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { ROUTER_CONFIG } from '@core/configs';
import { VersionService } from '@core/services/apis';
import { MultipleSpinnerService } from '@core/services/common';

const enum Type {
  VERSION = 'version',
}

export const pdfPreviewResolver: ResolveFn<any> = async (route: ActivatedRouteSnapshot): Promise<any> => {
  const router = inject(Router);
  const versionService = inject(VersionService);
  const multipleSpinnerService = inject(MultipleSpinnerService);
  const id = Number(route.paramMap.get('id'));

  if (!id) {
    return await router.navigate([ROUTER_CONFIG.notFound]);
  }

  const type = route.paramMap.get('type');
  try {
    if (type === Type.VERSION) {
      multipleSpinnerService.show();
      const res = await versionService.getAttachment(id).toPromise();
      multipleSpinnerService.hide();
      if (res && res.result) {
        return res.result;
      } else {
        return await router.navigate([ROUTER_CONFIG.notFound]);
      }
    } else {
      return await router.navigate([ROUTER_CONFIG.notFound]);
    }
  } catch (e) {
    multipleSpinnerService.hide();
    return await router.navigate([ROUTER_CONFIG.notFound]);
  }
};
